import * as React from 'react';

function CheckCircle(props) {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", role: "presentation", focusable: "false", fill: "currentColor", viewBox: "0 0 16 16", className: "c-pieIcon c-pieIcon--checkCircle", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M1.478 8C1.478 4.4 4.4 1.478 8 1.478S14.522 4.4 14.522 8 11.6 14.522 8 14.522A6.524 6.524 0 0 1 1.478 8Zm1.305 0A5.222 5.222 0 0 0 8 13.217 5.221 5.221 0 0 0 13.217 8 5.222 5.222 0 0 0 8 2.783 5.222 5.222 0 0 0 2.783 8Zm2.887-.27L7 9.191l.009-.008 3.339-3.626.956.886-3.565 3.87a1.006 1.006 0 0 1-1.47.009L4.705 8.609l.966-.879Z", clipRule: "evenodd" })));
}

export { CheckCircle as default };
